import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as moment from 'moment';

import { AddEditPurchaseInvoiceComponent } from './addEditPurchaseInvoice.component';
import { PurchaseInvoiceModel } from '../../../model/index';
import { PurchaseInvoiceService, SubscribeService } from '../../../services/index';

@Component({
    selector: 'purchaseInvoice-tab',
    templateUrl: './purchaseInvoice.component.html',
})

export class PurchaseInvoiceComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    public mode: string;
    public list: any[] = [];
    public salesbillentrydata: any[] = [];

    isLoadMask: Promise<any>;
    salesbillentryData: PurchaseInvoiceModel[];
    isLoading: boolean = false;

    constructor(private purchaseInvoiceService: PurchaseInvoiceService,
        public subscribeService: SubscribeService,
        private modalService: BsModalService) { }

    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'purchase_id',
        orderDir: 'desc'
    };
    filterData = {
        "search_name": "",
        "from_date": new Date(),
        "to_date": new Date()
    };
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    columns = [];
    toggleCol = [];

    ngOnInit(): void {
        let that = this;
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 50, minWidth: 50, maxWidth: 50, sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Purchase Invoice', prop: 'auto_no', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Receipt No', prop: 'receipt_no', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Purchase Date', prop: 'disp_date', width: 130, minWidth: 130, maxWidth: 130 },
            { name: 'Party Name', prop: 'party_name', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Branch', prop: 'company_name', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'HV Team', prop: 'hv_username', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Total Quantity', prop: 'quantity', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Discount', prop: 'discount_amount', width: 110, minWidth: 110, maxWidth: 110 },
            { name: 'Total Amount', prop: 'grand_total', width: 130, minWidth: 130, maxWidth: 130 },
            { name: 'Action', prop: 'sno', width: 180, minWidth: 180, maxWidth: 180, sortable: false, cellClass: 'cell-left', cellTemplate: this.editDeleteTemplate }
        ];
        this.toggleCol = Object.assign({}, this.columns);

        this.pageCallback({ offset: 0 });
        //THIS WILL WORK WHEN BILL SAVED IN OTHER TAB
        this.subscribeService.publishReloadSalesBillentryListGrid().subscribe(($e) => {
            that.pageCallback({ offset: 0 });
        });
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        this.page.offset = pageInfo.offset;
        this.getPurchaseInvoiceList();
    }

    /**
   * Called whenever the user changes the sort order
   */
    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
        // there will always be one "sort" object if "sortType" is set to "single"
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.getPurchaseInvoiceList();
    }
    onColumnToggle(colToShow) {
        this.columns = colToShow;
    }
    onOpenedFilter(): void {
        setTimeout(function () {
            $('#filterSearch').focus();
        }, 100);

    }
    clearFilter(): void {
        this.filterData = {
            "search_name": "",
            "from_date": new Date(),
            "to_date": new Date()
        };
        this.applyFilter();
    }
    applyFilter(): void {
        this.filterPanel.close();
        this.getPurchaseInvoiceList();
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getPurchaseInvoiceList();
    }
    getPurchaseInvoiceList(): void {
        let that = this,
            params = {
                start: `${this.page.offset}`,
                limit: `${this.page.limit}`,
                orderColumn: `${this.page.orderBy}`,
                orderDir: `${this.page.orderDir}`,
                search_name: this.filterData['search_name'],
                from_date: moment(this.filterData['from_date']).format('YYYY-MM-DD'),
                to_date: moment(this.filterData['to_date']).format('YYYY-MM-DD'),
                from_page: this['params']['tabParams'],
                mode: this['params']['mode']
            };

        this.isLoadMask = this.purchaseInvoiceService
            .getPurchaseInvoiceList(params)
            .then(function (res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.salesbillentrydata = res.data;
            });
    }


    addPurchaseInvoice(mode: string, row: any): void {
        let that = this;
        setTimeout(function () {
            that.filterPanel.close();
        }, 10);

        if (mode == "Add") {
            row = {
                'bill_id': '',
                'mode': mode
            };
        } else if (mode == "Edit") {
            row['mode'] = mode;
        } else if (mode == "View") {
            row['mode'] = mode;
        }

        that.subscribeService.subScribeTabID('Transaction', 'AddEditPurchaseInvoiceComponent', row, this['params']['tabParams']);
    }

    onDeletePurchaseInvoiceEntry(row: any): void {
        let that = this,
            params = {
                purchase_id: row.purchase_id
            };
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover this Purchase Invoice Details, No - ' + row['auto_no'],
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function () {
            that.loadingIndicator = true;
            that.isLoadMask = that.purchaseInvoiceService
                .deletePurchaseInvoiceEntry(params)
                .then(function (res: any) {
                    that.loadingIndicator = false;
                    if (res.success) {
                        that.getPurchaseInvoiceList();
                        swal(
                            'DELETED',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }
                });

        }, function (dismiss) {

        })




    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/purchaseInvoice/purchaseInvoice.component.ts